import { msg } from '@lingui/core/macro';

export const SHARED_LOCKED_CONTENT_TITLE = msg`This content is locked`;
export const SHARED_LOCKED_CONTENT_DESCRIPTION = msg`Complete all Mandatory Learning to unlock this section.`;
export const SHARED_LOCKED_CONTENT_BUTTON = msg`View mandatory learning`;
